"use client";
import Link from 'next/link';

const services = [
  {
    id: 'glossary',
    title: 'القاموس المختصر',
    description: 'قاموس شامل لمصطلحات UI/UX باللغتين العربية والإنجليزية مع شرح مفصل لكل مصطلح',
    href: '/services/glossary',
    icon: 'bi bi-book',
    iconColor: '#9C27B0',
    badge: 'مصطلحات',
    featured: true
  },
  {
    id: 'surveys',
    title: 'الاستبيانات',
    description: 'شاركنا رأيك وتجربتك من خلال استبيانات قصيرة — واجهة مريحة بدون ضغط زمني',
    href: '/services/surveys',
    icon: 'bi bi-ui-checks',
    iconColor: '#0d6efd',
    badge: 'مجتمع',
    featured: true
  },
  {
    id: 'figma-shortcuts',
    title: 'Figma Shortcuts',
    description: 'اختصارات فيجما الأساسية للمصممين — دليل سريع ومنظم يساعدك تشتغل أسرع داخل Figma باستخدام اختصارات لوحة المفاتيح الأكثر استخدامًا.',
    href: '/services/figma-shortcuts',
    icon: 'bi bi-keyboard',
    iconColor: '#111827',
    badge: 'أدوات',
    featured: true
  },
  // {
  //   id: 'quizzes',
  //   title: 'الاختبارات',
  //   description: 'اكتشف مستواك واحصل على توصيات تعليمية مخصصة من خلال اختباراتنا التفاعلية',
  //   href: '/services/quizzes',
  //   icon: 'bi bi-clipboard-check',
  //   iconColor: '#6C5CE7',
  //   badge: 'تعليمي',
  //   featured: true
  // },
  {
    id: 'calc',
    title: 'حاسبة التسعير',
    description: 'احسب تسعير مشاريع التصميم بشكل منطقي واحترافي مع مراعاة جميع البنود المهمة',
    href: '/services/calc',
    icon: 'bi bi-calculator',
    iconColor: '#00B894',
    badge: 'أدوات',
    featured: true
  },
  // {
  //   id: 'courses',
  //   title: 'الدورات التعليمية',
  //   description: 'مجموعة مختارة من أفضل الدورات التعليمية لتطوير مهاراتك في تصميم الواجهات وتجربة المستخدم',
  //   href: '/services/courses',
  //   icon: 'bi bi-mortarboard',
  //   iconColor: '#E17055',
  //   badge: 'تعليمي',
  //   featured: false
  // },
  {
    id: 'cert',
    title: 'الشهادات',
    description: 'تحقق من صلاحية وموثوقية شهادات فيجماوية أو احصل على شهادتك الخاصة',
    href: '/services/cert',
    icon: 'bi bi-award',
    iconColor: '#FDCB6E',
    badge: 'شهادات',
    featured: false
  },
  {
    id: 'design-reviews',
    title: 'مراجعة التصاميم',
    description: 'اطلب مراجعة لتصاميمك واحصل على تعليقات بناءة من مجتمع المصممين المحترفين',
    href: '/services/design-reviews',
    icon: 'bi bi-eye',
    iconColor: '#6C5CE7',
    badge: 'مجتمع',
    featured: false
  },
  {
    id: 'short',
    title: 'إختصار الروابط',
    description: 'أنشئ روابط مختصرة مخصصة مع تتبع الإحصائيات وإنشاء رموز QR للروابط',
    href: '/services/short',
    icon: 'bi bi-scissors',
    iconColor: '#00B894',
    badge: 'أدوات',
    featured: false
  }
];

export default function ServicesPage() {
  return (
    <main className="container py-5" dir="rtl">
      {/* Header */}
      <div className="text-center mb-5">
        <h1
          className="display-4 fw-bold mb-3"
          style={{
            background: 'linear-gradient(135deg, #9C27B0 0%, #6C5CE7 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}
        >
          خدمات فيجماوية
        </h1>
        <p className="lead text-muted mx-auto" style={{ maxWidth: '700px' }}>
          اكتشف جميع الخدمات المتاحة في منصة فيجماوية للمصممين والمطورين. من الأدوات التعليمية إلى الخدمات العملية
        </p>
      </div>

      {/* Services Grid */}
      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
        {services.map((service) => (
          <div key={service.id} className="col">
            <Link
              href={service.href}
              className="text-decoration-none"
              style={{ display: 'block', height: '100%' }}
            >
              <div
                className="card border-0 shadow-sm h-100 position-relative"
                style={{
                  borderRadius: '16px',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
              >
                {/* Featured Badge */}
                {service.featured && (
                  <span
                    className="position-absolute top-0 start-0 m-2 px-2 py-1 rounded-pill text-white small fw-bold"
                    style={{
                      background: 'linear-gradient(135deg, #FF6B6B 0%, #FF8C00 100%)',
                      fontSize: '0.75rem',
                      zIndex: 2,
                      boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                    }}
                  >
                    مميز
                  </span>
                )}

                {/* Icon Section */}
                <div
                  className="d-flex align-items-center justify-content-center p-4"
                  style={{
                    background: `linear-gradient(135deg, ${service.iconColor}15 0%, ${service.iconColor}05 100%)`,
                    minHeight: '180px'
                  }}
                >
                  <i
                    className={`bi ${service.icon}`}
                    style={{
                      fontSize: '4rem',
                      color: service.iconColor
                    }}
                  ></i>
                </div>

                {/* Card Body */}
                <div className="card-body p-4">
                  {/* Badge */}
                  <div className="mb-2">
                    <span
                      className="badge bg-light text-dark border"
                      style={{
                        fontSize: '0.7rem',
                        fontWeight: '600',
                        letterSpacing: '0.5px'
                      }}
                    >
                      {service.badge}
                    </span>
                  </div>

                  {/* Title */}
                  <h5
                    className="fw-bold mb-2"
                    style={{
                      fontSize: '1.25rem',
                      color: '#333',
                      lineHeight: '1.4',
                      minHeight: '3.5rem'
                    }}
                  >
                    {service.title}
                  </h5>

                  {/* Description */}
                  <p
                    className="text-muted mb-3"
                    style={{
                      fontSize: '0.875rem',
                      lineHeight: '1.6',
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      minHeight: '4.2rem'
                    }}
                  >
                    {service.description}
                  </p>

                  {/* CTA */}
                  <div className="d-flex align-items-center gap-2 text-primary">
                    <span className="small fw-bold">استكشف الخدمة</span>
                    <i className="bi bi-arrow-left"></i>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      {/* Additional Info Section */}
      <div className="mt-5 pt-4 text-center">
        <div className="card bg-light border-0 rounded-4 p-4">
          <h5 className="fw-bold mb-3">هل تبحث عن خدمة معينة؟</h5>
          <p className="text-muted mb-0">
            إذا كان لديك اقتراح لخدمة جديدة أو تحتاج مساعدة في استخدام أي من الخدمات المتاحة،
            <Link href="/pages/contact" className="text-decoration-none fw-bold text-primary"> تواصل معنا</Link>
          </p>
        </div>
      </div>
    </main>
  );
}
